

export default function MenuView() {
    return (
      <div className="flex justify-center items-center bg-gray-200 h-full">
        A list of Translators in the building will be here
      </div>
    );
  }
  